import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { getSymbol } from '../../../../config/helper';
import { amountFormat } from '../../../../utils';

const MISCards = ({ data }) => {
	const styles = StyleSheet.create({
		page: {
			paddingTop: 60,
			paddingLeft: 10,
			paddingRight: 10,
			lineHeight: 1.5,
			flexDirection: 'column',
		},
		mainContainer: {
			width: '100%',
			flexDirection: "column",
		},
		Headercontainer: {
			flexDirection: 'row',
			backgroundColor: '#E4E4E4',
			alignItems: 'center',
			fontStyle: 'bold',
			paddingBottom: '5px',
			paddingTop: '10px',
			paddingLeft: '15px'
		},
		text: {
			width: "8.33%",
			marginRight: "5px",
			fontSize: "8px",
			color: "#333333"
		},
		Datacontainer: {
			flexDirection: 'row',
			alignItems: 'center',
			fontStyle: 'bold',
			paddingBottom: '5px',
			paddingTop: '10px',
			paddingLeft: '15px',
			border: "1px solid #E4E4E4",
			borderRadius: '5px',
			width: '100%',
			marginTop: '5px',
		},
		data: {
			width: "8.33%",
			marginRight: "5px",
			fontSize: "8px",
			color: "#333333",
		},
	});
	const Columns = ["Employee ID", "CRN", "Employee Name", "Cost center", "Project", "Transaction Date", "Merchant Name", "Transaction Amount", "Wallet name", "Merchant MCC", "Transaction Type", "Approval Status"]
	const wrapText = (text, maxLength) => {
		if (text.length <= maxLength) return text;
		const words = text.split('');
		let wrappedText = '';
		let line = '';

		for (let i = 0; i < words.length; i++) {
			const word = words[i];
			if (line.length + word.length <= maxLength) {
				line += word + '';
			} else {
				wrappedText += line.trim() + '\n';
				line = word + '';
			}
		}

		return wrappedText + line.trim();
	};
	return (
		<Document>
			<Page size="A4" style={styles.page} orientation='landscape'>
				<View style={styles.mainContainer}>
					<View style={styles.Headercontainer}>
						{
							Columns.map((item, index) => {
								return <Text key={index} style={styles.text}>{item}</Text>
							})
						}
					</View>
					{
						data?.map((items, index) => {
							const wrappedReference = wrapText(
								items?.card_reference_no ? items?.card_reference_no : '-',
								7 // Adjust the maximum character count as needed
							);
							return (
								<View style={styles.Datacontainer}>
									<Text style={styles.data}>{items?.employee_id ? items?.employee_id : "-"}</Text>
									<Text style={styles.data}>{wrappedReference}</Text>
									<Text style={styles.data}>{items?.employee_name ? items?.employee_name : "-"}</Text>
									<Text style={styles.data}>{items?.cost_center ? items?.cost_center : "-"}</Text>
									<Text style={styles.data}>{items?.project ? items?.project : "-"}</Text>
									<Text style={styles.data}>{items?.transaction_date ? items?.transaction_date : "-"}</Text>
									<Text style={styles.data}>{items?.merchant ? items?.merchant : "-"}</Text>
									<Text style={styles.data}>{items?.transaction_amount ? getSymbol() + " " + amountFormat(items?.transaction_amount) : "-"}</Text>
									<Text style={styles.data}>{items?.wallet_name ? items?.wallet_name : "-"}</Text>
									<Text style={styles.data}>{items?.merchant_mcc ? items?.merchant_mcc : "-"}</Text>
									<Text style={styles.data}>{items?.transaction_type ? items?.transaction_type === "Dr" ? "Debit" : items?.transaction_type !== null ? "Credit" : "" : "-"}</Text>
									<Text style={styles.data}>{items?.approval_status ? items?.approval_status : "-"}</Text>
								</View>

							)
						})
					}
				</View>
			</Page>
		</Document>
	)
}

export default MISCards;